import {cookieStore} from 'libs/storage/storage';

import {RETURNING_CUSTOMER_COOKIE_KEY} from './constants';

/**
 * Checks cookie storage for returningCustomer record
 */
export const getIsReturningCustomerCL = () =>
    Boolean(cookieStore.get(RETURNING_CUSTOMER_COOKIE_KEY));
